import { AfterViewChecked, Component, ViewChild } from '@angular/core';
import { Prodotto } from "../../Progetti/Models/Prodotto";
import { ClassicType } from "../../shared/models/ClassicType";
import { ActivatedRoute, Router } from "@angular/router";
import { ApiRestService as ProgettiApiRestService } from "../../Progetti/_services/api-rest.service";
import { FileStoreService } from "../../shared/_services/file-store.service";
import { ProdottiStoreService } from "../../Progetti/_services/prodotti-store.service";
import { ToastrService } from "ngx-toastr";
import { Location } from "@angular/common";
import { RicercaPaginazione } from "../../Admin/models/sendpersonale";
import { Categorie } from '../../Progetti/Models/Categorie';
import { environment } from "../../../environments/environment";
import { TranslateObj } from "../../shared/models/translatedesc";
import { FileUploaderComponent } from "../../shared/file-uploader/file-uploader.component";
import { Azienda } from "../../Admin/models/Azienda";
import { Persona } from "../../Admin/models/persona";
import { ApiPathsService } from "../../api-paths.service";
import { Permission } from "../../Login/_guards/Permission";
import { IDropdownSettings } from "../../../LibrerieCustom/MultiselectDropdown";
import { data } from "jquery";

@Component({
  selector: 'app-editor-prodotti',
  templateUrl: './editor-prodotti.component.html',
})
export class EditorProdottiComponent implements AfterViewChecked {
  AddOn = environment.ProdottiAddOn;
  DropdownSources: { Agenti?: Persona[], Clienti?: Azienda[] } = { Agenti: [], Clienti: [] };
  unitadropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    textField: 'label',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: false,
    allowRemoteDataSearch: true,
  };
  tipiDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    closeDropDownOnSelection: true,
    textField: 'label',
    idField: 'id'
  };
  categoriedropdownSettings: IDropdownSettings = {
    singleSelection: environment.ProdottiAddOn['CategoriaSingola'],
    closeDropDownOnSelection: true,
    textField: 'categoria',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: true,
    allowRemoteDataSearch: true,
  };
  PersoneDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    closeDropDownOnSelection: true,
    textField: 'fullName',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: true,
    allowRemoteDataSearch: true,
  };
  keyaccountDropdownSettings: IDropdownSettings = {
    singleSelection: true,
    singleOutput: true,
    closeDropDownOnSelection: true,
    textField: 'nominativo',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: true,
    allowRemoteDataSearch: true,
  }
  keyaccount: any[] = [];
  private id: number;
  Item: Prodotto = new Prodotto();
  prezzo: string = "";
  UnitaDiMisura: ClassicType[] = [];
  UnitaDiMisuraSelezionata: ClassicType[] = [];
  Categorie: Categorie[] = [];
  CategorieObject: Categorie[] = [];
  Tipologie: ClassicType[] = [];
  TipologieSelezionate: ClassicType[] = [];
  TipiProdotto: ClassicType[] = [];
  TipiProdottoSelezionati: ClassicType[] = [];
  ClassiEnergetiche: any;
  ClassiEnergeticheSelezionate: any;
  environment = environment;
  Taglie: any[] = [];
  private Backup: Prodotto;

  @ViewChild('fileUpload') private fileUpload: FileUploaderComponent;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private progettiApiRest: ProgettiApiRestService,
    private filestore: FileStoreService,
    private progettiStore: ProdottiStoreService,
    private toastService: ToastrService,
    private location: Location,
    private apiPath: ApiPathsService,
    public permission: Permission
  ) {
    this.route.params.subscribe(data => {
      this.id = parseInt(data['id']);
      this.Refresh(this.id);
    })
    this.Item.transaltedobjects = this.createlang(["en", "es", "fr", "de"]);
  }
  ngAfterViewChecked() {
    // this.Backup = Object.assign({}, this.Item);
  }

  Refresh(id: number) {
    this.filtroCategoria("");
    if (id) {
      this.progettiApiRest.getInfoProdotto({ id: id }).subscribe(data => {
        this.Item = data;
        this.compilaForm(data);
        this.filestore.SelectSection('prodotto');
        this.filestore.SetListaFile(data.files);
      });
    }
    else {
      if (this.AddOn['taglie'])
        this.GetTaglie();
    }
    this.progettiStore.getUnitaDiMisura();
    this.progettiStore.getTypes();
    if (environment.ProdottiAddOn['keyaccount'])
      this.apiPath.ClassicPost("/anagrafica/clienti/list", { page: 1, size: 2000, ruolo: 'K' }).subscribe(data => {
        this.keyaccount = data?.data;
      })
    this.progettiStore.$unitaDiMisura.subscribe(data => this.UnitaDiMisura = data !== null ? data : []);
    this.progettiStore.$types.subscribe(data => this.Tipologie = data !== null ? data : []);
    this.progettiStore.$categorieProdottiLineare.subscribe(data => this.Categorie = data);
    if (this.AddOn.tipi)
      this.progettiApiRest.GetTipiProdotto().subscribe(data => this.TipiProdotto = data);
    if (this.AddOn.classeEnergetica)
      this.progettiApiRest.GetClassiEnergetiche().subscribe(data => this.ClassiEnergetiche = data);
  }
  getids(value: any[]): number[] {
    return value?.map(item => item.id) ?? [];
  }

  getid(value: any[], ifempty?: any[]): any {
    return value?.map(item => item.id)?.find(x => true) ?? (ifempty ? this.getid(ifempty) : null);
  }

  GetCost(scheda?: { parti_cat: { enabled: boolean, qta: number, prezzo?: number, parte_id?: number }[] }) {
    console.log("GetCosto")
    var sel = scheda ?? this.Item['schede']?.find(x => true);
    if (!(sel?.parti_cat?.length > 0)) return 0;
    return sel.parti_cat?.filter(x => (x.parte_id || x.parteObject) && x.prezzo > 0)?.map(x => (x.prezzo ?? 0) * (x.qta ?? 1))?.reduce((acc, cur) => acc + cur, 0)?.toFixed(2) ?? 0;
  }

  private compilaForm(data: Prodotto) {
    if (this.AddOn['prezzoSingolo'] && data.prezzi?.length > 0)
      this.Item.prezzo = data.prezzi[0].prezzo;
    if (this.AddOn['taglie'])
      this.GetTaglie();
    if (!(this.Item?.costo > 0))
      this.Item.costo = this.GetCost();
    this.TipologieSelezionate = data.tipoObject ? [data.tipoObject] : [];
    this.TipiProdottoSelezionati = data.tipiObject ? data.tipiObject : [];
    this.ClassiEnergeticheSelezionate = data.catEnergeticaObject ? [data.catEnergeticaObject] : [];
    this.CategorieObject = data.categorie ? data.categorie : [];
    this.Item.transaltedobjects = data.id ? this.gettransaltedobjects(data) : this.createlang(["en", "es", "fr", "de"]);
    this.Backup = this.Item;
    console.log(this.Item)
  }

  private GetTaglie() {
    this.Taglie = [];
    this.apiPath.ClassicPost('/prodotti/taglia/list', { page: 0, size: 10 }).subscribe(data => {
      this.Taglie = data.data;
      this.Taglie.forEach(taglia => {
        var tag = this.Item?.taglie?.find(x => x.id == taglia.id);
        console.log("tag", tag);
        taglia.selected = tag != null
        taglia.magazzino = tag ? (tag.magazzino ?? 0) : 0;
      })
    })
  }

  private getDaForm() {
    this.updateFields(this.Item?.transaltedobjects)
    var out: Prodotto = this.Item;
    if (this.AddOn['prezzoSingolo'])
      out.prezzi = [{ prezzo: this.Item.prezzo, um: 64, umlabel: "Pz" }];
    out.categorie = this.getids(this.CategorieObject);
    out.correlati = [...this.getids(this.Item?.correlatiObject) ?? [], ...out.ricambiObject?.map(x => x.id) ?? []];
    out.tipo = this.getid(this.TipologieSelezionate, this.Tipologie);
    out.tipi = this.getids(this.TipiProdottoSelezionati);
    out.catEnergetica = this.getid(this.ClassiEnergeticheSelezionate);
    out.cliente = this.Item?.clienteObject?.id
    if (this.AddOn['taglie']) {

      out['magazzino'] = this.Taglie?.filter(x => x.selected)?.map(x => x.magazzino)?.reduce((acc, cur) => acc + cur, 0) ?? 0;
      out.taglie = this.Taglie?.filter(x => x.selected);

    }
    out.ricambi = out.ricambiObject?.map(x => {
      return {
        id: x.id,
        posizione: x.posizione
      }
    });
    if (this.AddOn.TranslatedDesc)
      this.Item?.transaltedobjects?.find(x => x.default)?.TranslateInputs?.forEach(translateInput => {
        out[translateInput?.id] = translateInput?.value;
      })
    return out;
  }
  addPrezzo() {
    this.Item.prezzi = this.Item.prezzi ? this.Item.prezzi : [];
    if (this.UnitaDiMisura?.length <= 1) {
      if (this.Item.prezzi.findIndex(x => x.um === parseInt(this.UnitaDiMisura[0].id)) < 0)
        this.Item.prezzi.push({
          prezzo: parseFloat(this.prezzo),
          um: parseInt(this.UnitaDiMisura[0].id),
          umlabel: this.UnitaDiMisura[0].label
        });
      else if (isNaN(parseFloat(this.prezzo)))
        this.toastService.warning("Inserire un prezzo", 'Attenzione!');
      else
        this.toastService.info("Questa unita di misura è stata gia inserita", 'Info!');
    }
    else if (this.UnitaDiMisuraSelezionata?.length > 0) {
      if (this.Item.prezzi.findIndex(x => x.um === parseInt(this.UnitaDiMisuraSelezionata[0].id)) < 0)
        this.Item.prezzi.push({
          prezzo: parseFloat(this.prezzo),
          um: parseInt(this.UnitaDiMisuraSelezionata[0].id),
          umlabel: this.UnitaDiMisuraSelezionata[0].label
        });
      else if (isNaN(parseFloat(this.prezzo)))
        this.toastService.warning("Inserire un prezzo", 'Attenzione!');
      else
        this.toastService.info("Questa unita di misura è stata gia inserita", 'Info!');
    }
    else
      this.toastService.warning("Inserire un unità di misura", 'Attenzione!');
    console.log(this.Item.prezzi);
  }
  deletePrezzo(value) {
    const idx = this.Item.prezzi.findIndex(x => x.um === value.um);
    if (idx > -1)
      this.Item.prezzi.splice(idx, 1);
  }

  async ImageChange(event, target, type: 'image' | 'pdf', filename?) {
    const blob: Blob = event.target.files[0];
    if (!blob.type.includes(type)) {
      this.toastService.warning("Questo formato non è supportato. Inserire solo " + type + ".", "Attenzione!")
      return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onload = () => {
      this.Item[target] = reader.result.toString().length > 1 ? reader.result.toString() : undefined;
      if (!filename) return;
      this.Item[filename] = reader.result.toString().length > 1 ? event.target.files[0].name : this.Item[filename];
    };
  }



  saveClick(close?: boolean) {
    if (this.Item.id)
      this.progettiApiRest.updateProdotti(this.getDaForm()).subscribe(() => {
        if (close)
          this.location.back()
      });
    else
      this.progettiStore.addNewItem(this.getDaForm()).subscribe(data => {
        if (close)
          this.location.back()
        else if (data?.id)
          this.Refresh(data?.id)
      });
  }
  filtroCategoria(item: string) {
    this.progettiStore.getCategorieListanofigli(new RicercaPaginazione(item, undefined, undefined));
  }
  onFileChanged() {
    this.Refresh(this.Item.id)
  }
  FileUploadButtonClick(param: { [p: string]: string | string[] }) {
    //if(confirm("Desideri salvare le eventuali modifiche prima di caricare il file? "))
    this.progettiApiRest.updateProdotti(this.getDaForm()).subscribe(() => {
      this.fileUpload.ExternalSave(param);
    });
    // else
    //   this.fileUpload.ExternalSave(param);
  }

  cancel() {
    this.location.back();
  }

  onImageError(prodotto: Prodotto) {
    // prodotto.UrlImmagine = 'assets/images/gallery/NoImageAvailable.png';
  }

  onschedaError(prodotto: Prodotto) {
    // prodotto.Urlscheda = 'assets/images/gallery/NoImageAvailable.png';
  }




  createlang(values: string[]): TranslateObj[] {
    var output: TranslateObj[] = [];
    output.push({
      default: true,
      lang: "it",
      TranslateInputs: [
        { id: "prodotto", label: "Prodotto", value: "", type: "text" },
        { id: "descrizione", label: "Descrizione", value: "", type: "textarea" },
        { id: "descrizioneBreve", label: "Descrizione breve", value: "", type: "textarea" },
        { id: "slug", label: "SEO Slug Italiano", value: "", type: "text" },
        { id: "seoTitle", label: "SEO Title Italiano", value: "", type: "text" },
        { id: "seoMeta", label: "SEO Meta description Italiano", value: "", type: "textarea" },
        { id: "seoDesc", label: "SEO Description Italiano", value: "", type: "textarea" },
        { id: "descEnergetica", label: "Descrizione Classe Energetica", value: "", type: "textarea" }
      ]
    })
    values?.forEach(value => {
      output.push({
        default: false,
        lang: value,
        TranslateInputs: [
          { id: "prodotto", label: "Prodotto", value: "", type: "text" },
          { id: "descrizione", label: "Descrizione", value: "", type: "textarea" },
          { id: "descrizioneBreve", label: "Descrizione breve", value: "", type: "textarea" },
          { id: "slug", label: "SEO Slug ", value: "", type: "text" },
          { id: "seoTitle", label: "SEO Title ", value: "", type: "text" },
          { id: "seoMeta", label: "SEO Meta description ", value: "", type: "textarea" },
          { id: "seoDesc", label: "SEO Description ", value: "", type: "textarea" },
          { id: "descEnergetica", label: "Descrizione Classe Energetica", value: "", type: "textarea" }
        ]
      })
    })
    return output;
  }

  gettransaltedobjects(prodotto: Prodotto): TranslateObj[] {
    return [
      {
        default: true,
        lang: "it",
        TranslateInputs: [
          { id: "prodotto", label: "Prodotto", value: prodotto.prodotto, type: "text" },
          { id: "descrizione", label: "Descrizione", value: prodotto.descrizione, type: "textarea" },
          { id: "descrizioneBreve", label: "Descrizione breve", value: prodotto.descrizioneBreve, type: "textarea" },
          { id: "slug", label: "SEO Slug Italiano", value: prodotto.slug, type: "text" },
          { id: "seoTitle", label: "SEO Title Italiano", value: prodotto.seoTitle, type: "text" },
          { id: "seoMeta", label: "SEO Meta description Italiano", value: prodotto.seoMeta, type: "textarea" },
          { id: "seoDesc", label: "SEO Description Italiano", value: prodotto.seoDesc, type: "textarea" },
          { id: "descEnergetica", label: "Descrizione Classe Energetica", value: prodotto.descEnergetica, type: "textarea" }
        ]
      }
    ].concat(prodotto.traduzioni);
  }

  updateFields(translateObjects: TranslateObj[]) {
    this.Item.traduzioni = translateObjects.filter(x => !x?.default)
  }


  Change(item: { OnChange: string; Event: any }) {
    switch (item.OnChange) {
      case 'CalcCosto':
        this.Item.costo = this.GetCost();
        break;
    }
  }

  schedasChange($event: any[]) {
    console.log("Schede di lavorazione cambiate", $event);
  }
}
